import React, { Component } from "react";
import * as KSLPlusAPI from "../services/KSLPlusAPI";
import * as sdk from "microsoft-cognitiveservices-speech-sdk";
import "./KIBot.css";
import { KIDatenBloecke, DatenRahmen } from "./KIDatenComp";

// KI-Assistent: runder Knopf und Chatfenster.
//   KIBotLogo       das KSL-Logo und die kleinen Symbole
//   KIBotBild       ein Bild aus dem Handbuch
//   KIBotNachricht  eine Frage mit ihrer Antwort
//   KIBotVerlauf    die Liste "Meine Chats"
//   KIBot           der Bot selbst: Knopf, Fenster, Zustand, alle Aufrufe an die API

const OBEN_LINKS = "M 337.53 43.99 C 337.60 49.60 337.60 55.20 337.56 60.81 C 334.79 60.82 332.02 60.84 329.26 60.87 C 329.16 70.44 329.34 80.01 329.14 89.59 C 319.63 89.56 310.11 89.59 300.60 89.56 C 300.57 92.32 300.53 95.09 300.52 97.85 C 294.83 97.85 289.15 97.78 283.46 97.62 C 283.75 80.79 291.86 64.48 305.55 54.57 C 314.77 47.66 326.02 44.07 337.53 43.99 Z";
const OBEN_RECHTS = "M 337.64 26.25 C 357.59 25.72 377.83 35.12 391.03 49.99 C 402.78 62.95 409.38 80.28 409.40 97.75 C 407.44 97.74 405.48 97.72 403.51 97.70 C 393.83 97.63 384.14 97.66 374.46 97.69 C 374.46 94.97 374.45 92.26 374.45 89.54 C 365.07 89.45 355.64 89.74 346.27 89.45 C 345.50 87.98 345.77 86.58 345.72 84.98 C 345.84 76.93 345.78 68.87 345.76 60.81 C 343.03 60.81 340.29 60.80 337.56 60.81 C 337.60 55.20 337.60 49.60 337.53 43.99 C 337.57 38.09 337.25 32.14 337.64 26.25 Z";
const UNTEN_RECHTS = "M 374.46 97.69 C 384.14 97.66 393.83 97.63 403.51 97.70 C 403.18 114.54 396.91 130.98 385.13 143.12 C 372.86 156.14 355.34 163.53 337.48 163.61 C 337.49 161.62 337.50 159.64 337.51 157.65 C 337.59 150.01 337.54 142.38 337.55 134.74 C 340.29 134.74 343.03 134.74 345.76 134.74 C 345.77 125.22 345.76 115.71 345.77 106.19 C 355.32 106.17 364.87 106.18 374.42 106.18 C 374.44 103.35 374.46 100.52 374.46 97.69 Z";
const UNTEN_LINKS = "M 277.40 97.50 C 279.42 97.54 281.44 97.58 283.46 97.62 C 289.15 97.78 294.83 97.85 300.52 97.85 C 300.51 100.57 300.52 103.29 300.52 106.01 C 310.08 106.36 319.64 106.09 329.21 106.20 C 329.27 115.71 329.21 125.22 329.24 134.74 C 332.01 134.74 334.78 134.74 337.55 134.74 C 337.54 142.38 337.59 150.01 337.51 157.65 C 318.36 157.82 299.62 148.06 288.64 132.40 C 281.31 122.27 277.56 109.97 277.40 97.50 Z";
const PLUS = "M 329.26 60.87 C 332.02 60.84 334.79 60.82 337.56 60.81 C 340.29 60.80 343.03 60.81 345.76 60.81 C 345.78 68.87 345.84 76.93 345.72 84.98 C 345.77 86.58 345.50 87.98 346.27 89.45 C 355.64 89.74 365.07 89.45 374.45 89.54 C 374.45 92.26 374.46 94.97 374.46 97.69 C 374.46 100.52 374.44 103.35 374.42 106.18 C 364.87 106.18 355.32 106.17 345.77 106.19 C 345.76 115.71 345.77 125.22 345.76 134.74 C 343.03 134.74 340.29 134.74 337.55 134.74 C 334.78 134.74 332.01 134.74 329.24 134.74 C 329.21 125.22 329.27 115.71 329.21 106.20 C 319.64 106.09 310.08 106.36 300.52 106.01 C 300.52 103.29 300.51 100.57 300.52 97.85 C 300.53 95.09 300.57 92.32 300.60 89.56 C 310.11 89.59 319.63 89.56 329.14 89.59 C 329.34 80.01 329.16 70.44 329.26 60.87 Z";

type LogoProps = {
    art?: "ruhe" | "arbeitet" | "aufbau",   // arbeitet = Welle, aufbau = neuer Chat
    groesse?: number
}

class KIBotLogo extends Component<LogoProps> {
    render() {
        const g = this.props.groesse ?? 28;
        return (
            <svg className={"kibot-logo kibot-logo--" + (this.props.art ?? "ruhe")}
                viewBox="271.7 23.2 143.4 143.4" width={g} height={g} aria-hidden="true">
                <path className="kibot-q kibot-ol" fill="#B9B9B8" d={OBEN_LINKS} />
                <path className="kibot-q kibot-or" fill="#00979F" d={OBEN_RECHTS} />
                <path className="kibot-q kibot-ur" fill="#727272" d={UNTEN_RECHTS} />
                <path className="kibot-q kibot-ul" fill="#9DCAD1" d={UNTEN_LINKS} />
                <path className="kibot-plus" fill="#FFFFFF" d={PLUS} />
            </svg>
        );
    }
}

// Rahmen für die kleinen Strich-Symbole
function Linie(props: { children: React.ReactNode }) {
    return (
        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth={1.7}
            strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            {props.children}
        </svg>
    );
}

// Die kleinen Symbole im Fenster
const Symbole = {
    liste: <Linie><path d="M3.5 5.5h13M3.5 10h13M3.5 14.5h8" /></Linie>,
    neu: <Linie><path d="M4 16V5.8A2.3 2.3 0 0 1 6.3 3.5h7.4A2.3 2.3 0 0 1 16 5.8v5.4a2.3 2.3 0 0 1-2.3 2.3H7.2L4 16z" /><path d="M10 6.2v4.6M7.7 8.5h4.6" /></Linie>,
    maximieren: <Linie><path d="M11.5 3.5h5v5M8.5 16.5h-5v-5M16.5 3.5 11 9M3.5 16.5 9 11" /></Linie>,
    verkleinern: <Linie><path d="M16 9h-5V4M4 11h5v5M11 9l5.5-5.5M9 11l-5.5 5.5" /></Linie>,
    zuklappen: <Linie><path d="M4.5 13.5h11" /></Linie>,
    dokument: <Linie><path d="M5.5 2.8h6l3.5 3.5v10.9H5.5z" /><path d="M11.5 2.8v3.5H15M7.8 10.5h4.6M7.8 13.3h4.6" /></Linie>,
    download: <Linie><path d="M10 3.5v9M6.2 9 10 12.8 13.8 9M4 16.5h12" /></Linie>,
    stift: <Linie><path d="M4 16l.9-3.7 8.4-8.4 2.8 2.8-8.4 8.4L4 16z" /><path d="M11.8 5.4l2.8 2.8" /></Linie>,
    eimer: <Linie><path d="M4.5 6h11M8 6V4.2h4V6M6 6l.7 10.2h6.6L14 6" /></Linie>,
    daumenHoch: <Linie><path d="M6.5 9v7.5h-3V9z" /><path d="M6.5 9l3-5.5c1 0 1.8.9 1.6 1.9L10.6 8h4.3c1.1 0 1.9 1 1.6 2l-1.2 5c-.2.9-1 1.5-1.9 1.5H6.5" /><path className="kibot-trennlinie" d="M6.5 8.1v9.3" /></Linie>,
    daumenRunter: <Linie><g transform="rotate(180 10 10)"><path d="M6.5 9v7.5h-3V9z" /><path d="M6.5 9l3-5.5c1 0 1.8.9 1.6 1.9L10.6 8h4.3c1.1 0 1.9 1 1.6 2l-1.2 5c-.2.9-1 1.5-1.9 1.5H6.5" /><path className="kibot-trennlinie" d="M6.5 8.1v9.3" /></g></Linie>,
    mikrofon: <Linie><rect x="7.5" y="2.5" width="5" height="9.5" rx="2.5" /><path d="M4.5 9.5a5.5 5.5 0 0 0 11 0M10 15v2.5M7 17.5h6" /></Linie>,
    lautsprecher: <Linie><path d="M3.5 7.5h3l4-3.5v12l-4-3.5h-3z" /><path d="M13.5 7.3a4 4 0 0 1 0 5.4M15.8 5.2a7 7 0 0 1 0 9.6" /></Linie>,
    stopp: <Linie><rect x="5.5" y="5.5" width="9" height="9" rx="1.5" /></Linie>,
    punkte: (
        <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <circle cx="4.5" cy="10" r="1.6" /><circle cx="10" cy="10" r="1.6" /><circle cx="15.5" cy="10" r="1.6" />
        </svg>
    )
};


// Daten einer Frage mit Antwort

// Eine Frage mit ihrer Antwort
type Runde = {
    frage: string,
    antwort?: string,                   // fehlt, solange die Antwort unterwegs ist
    confidence?: number,
    quellen?: KSLPlusAPI.RagSource[],
    fehler?: string,                    // gesetzt, wenn die Anfrage fehlgeschlagen ist
    historieID?: number,                // Zeile in KIBotHistorie, für die Bewertung
    bewertung?: number,                 // 1 = hilfreich, -1 = nicht hilfreich, leer = nicht bewertet
    bloecke?: KSLPlusAPI.AntwortBlock[],    // Datenassistent: Tabellen und Diagramme
    abgefragt?: string[],
    vorschlaege?: string[]              // Folgefragen zum Anklicken
    verlaufText?: string                // geht bei der nächsten Frage als Verlauf mit
}

// "1.1.2 Diagrammfarben.docx" -> "1.1.2 Diagrammfarben"
function dokumentName(quelle: KSLPlusAPI.RagSource): string {
    return (quelle.title || "Dokument").replace(/\.docx$/i, "");
}


// Sprache: Reinsprechen und Vorlesen über Azure Speech.
// Der Schlüssel bleibt auf dem Server. Der Browser holt sich über api/Ai/sprachToken ein Token, das 10 Minuten gilt.

type SprachZugang = {
    token: string,
    region: string,
    geholt: number          // Zeitpunkt des Abrufs (Date.now())
}

const SPRACH_TOKEN_MS = 9 * 60 * 1000;      // Token nach 9 Minuten erneuern (Empfehlung von Microsoft)
const STIMME = "de-DE-ConradNeural";        // männliche deutsche Stimme, passend zu "Paul"
const FACHWOERTER = ["KSLplus", "Haushaltsstelle", "Haushaltsstellen", "Produktkonto", "Produktkonten",
    "Planstufe", "Planstufen", "Doppik", "Kameralistik", "Verwaltungstool", "Visualisierung",
    "Begrüßungstext", "Diagrammfarben", "Erläuterungstexte", "Jahresrechnung", "UBW"];
const SPRACHE_NICHT_DA = "Die Spracheingabe ist gerade nicht verfügbar. Sie können die Frage weiterhin eintippen.";
const MIKROFON_FEHLER = "Das Mikrofon konnte nicht gestartet werden. Bitte erlauben Sie dem Browser den Zugriff auf das Mikrofon.";
const VORLESEN_FEHLER = "Die Antwort kann gerade nicht vorgelesen werden.";

// Das Mikrofon gibt der Browser nur über https oder auf localhost frei
const SPRACHE_MOEGLICH = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);

// Vorgelesene Antworten merken, damit dieselbe Antwort nicht zweimal bezahlt wird (historieID -> MP3)
const vorleseCache: { [historieID: number]: ArrayBuffer } = {};

// Der API-Client kennt sprachToken erst, wenn er neu erzeugt wurde. Bis dahin direkt abrufen.
function sprachTokenAbrufen(apiUrl: string, token: string): Promise<SprachZugang> {
    return fetch(apiUrl + "/api/Ai/sprachToken", { headers: { "Authorization": token } })
        .then(antwort => {
            // Fehler mit status, wie beim API-Client, damit mitToken 401 erkennt
            if (!antwort.ok) throw Object.assign(new Error("sprachToken"), { status: antwort.status });
            return antwort.json();
        })
        .then(daten => ({ token: daten.token, region: daten.region, geholt: Date.now() }));
}

// Nur das vorlesen, was man auch hört: ohne Bilder, Quellenmarken und Formatierung
function vorleseText(antwort: string): string {
    return antwort
        .replace(/\[\/?Bild[^\]]*\]/gi, " ")
        .replace(/\s*\[\d+\]/g, "")
        .replace(/\*\*/g, "")
        .replace(/^\s*[-•]\s+/gm, "")
        .replace(/KSLplus/gi, "KSL plus")
        .trim();
}

// Text in Sprache umwandeln. Ergebnis sind die Daten einer MP3-Datei.
function sprachausgabe(z: SprachZugang, text: string): Promise<ArrayBuffer> {
    return new Promise((ok, fehler) => {
        const config = sdk.SpeechConfig.fromAuthorizationToken(z.token, z.region);
        config.speechSynthesisVoiceName = STIMME;
        config.speechSynthesisOutputFormat = sdk.SpeechSynthesisOutputFormat.Audio24Khz48KBitRateMonoMp3;

        // null = nicht sofort abspielen, sondern das Audio zurückgeben (zum Merken und Anhalten)
        const sprecher = new sdk.SpeechSynthesizer(config, null);
        sprecher.speakTextAsync(text,
            ergebnis => {
                sprecher.close();
                if (ergebnis.reason === sdk.ResultReason.SynthesizingAudioCompleted)
                    ok(ergebnis.audioData);

                else
                    fehler(ergebnis.errorDetails);
            },
            e => {
                sprecher.close();
                fehler(e);
            });
    });
}
// Ein gemeinsamer Tonausgang für Klänge und Vorlesen. Er bleibt offen, dadurch muss
// das Ausgabegerät (Lautsprecher, Kopfhörer) nicht jedes Mal neu aufwachen.
let tonKontext: AudioContext | null = null;

function tonAusgang(): AudioContext {
    if (!tonKontext) {
        const Kontext = (window as any).AudioContext || (window as any).webkitAudioContext;
        tonKontext = new Kontext() as AudioContext;
    }
    if (tonKontext.state === "suspended") tonKontext.resume();
    return tonKontext;
}

// Stille vor dem Vorlesen, falls das Ausgabegerät doch erst aufwachen muss (in Sekunden)
const VORLAUF = 0.4;

// Kurzer Klang am Mikrofon: an = zwei Töne aufwärts, aus = dieselben Töne abwärts
function mikrofonKlang(an: boolean) {
    try {
        const ton = tonAusgang();
        const hoehen = an ? [660, 990] : [990, 660];
        hoehen.forEach((hoehe, i) => {
            const beginn = ton.currentTime + i * 0.09;
            const schwingung = ton.createOscillator();
            const lautstaerke = ton.createGain();
            schwingung.type = "sine";
            schwingung.frequency.value = hoehe;
            // Weich ein- und ausblenden, sonst knackt es
            lautstaerke.gain.setValueAtTime(0.0001, beginn);
            lautstaerke.gain.exponentialRampToValueAtTime(0.30, beginn + 0.01);
            lautstaerke.gain.exponentialRampToValueAtTime(0.0001, beginn + 0.08);
            schwingung.connect(lautstaerke);
            lautstaerke.connect(ton.destination);
            schwingung.start(beginn);
            schwingung.stop(beginn + 0.09);
        });
    }
    catch (e) {
        // Ohne Klang geht es auch
    }
}

// Ein Bild aus dem Handbuch

type BildProps = {
    pfad: string,
    apiUrl: string,
    token: () => string,
    erneuereToken: () => Promise<boolean>,
    onGrossansicht: (url: string) => void
}

type BildState = {
    url: string | null,
    fehler: boolean
}

// Geladene Bilder merken, damit sie beim erneuten Öffnen eines Chats nicht neu geladen werden
const bildCache: { [pfad: string]: string } = {};

class KIBotBild extends Component<BildProps, BildState> {
    private aktiv = true;

    constructor(props: BildProps) {
        super(props);
        this.state = { url: bildCache[props.pfad] || null, fehler: false };
    }

    componentDidMount() {
        if (!this.state.url)
            this.laden(true);
    }

    componentWillUnmount() {
        this.aktiv = false;
    }

    laden = (nochmalVersuchen: boolean) => {
        const client = new KSLPlusAPI.Ai_Client(this.props.apiUrl);

        client.bild(this.props.pfad, this.props.token()).then(datei => {
            const url = URL.createObjectURL(datei.data);
            bildCache[this.props.pfad] = url;
            if (this.aktiv) this.setState({ url: url });
        }).catch(Reason => {
            if (Reason && Reason.status == 401 && nochmalVersuchen) {
                this.props.erneuereToken().then(ok => { if (ok) this.laden(false); });
            }
            else if (this.aktiv) {
                
                this.setState({ fehler: true });
            }
        });
    }

    render() {
        if (this.state.fehler)
            return null;

        if (!this.state.url)
            return <div className="kibot-bild-laedt"><KIBotLogo art="arbeitet" groesse={28} /></div>;

        const url = this.state.url;
        return (
            <button type="button" className="kibot-bild" title="Bild vergrößern" onClick={() => this.props.onGrossansicht(url)}>
                <img src={url} alt="Abbildung aus dem Handbuch" />
            </button>
        );
    }
}

// Eine Frage mit Antwort


type NachrichtProps = {
    runde: Runde,
    index: number,
    botName: string,
    wartetext: string,
    apiUrl: string,
    token: () => string,
    erneuereToken: () => Promise<boolean>,
    onErneutSenden: (index: number) => void,
    onGrossansicht: (url: string) => void,
    onDokument: (quelle: KSLPlusAPI.RagSource, herunterladen: boolean) => void,
    onBewerten: (index: number, wert: number) => void,
    vorlesen: boolean,                  // diese Antwort wird gerade vorgelesen
    onVorlesen: (historieID: number) => void,
    onVorschlag?: (text: string) => void    // nur bei der letzten Antwort gesetzt
}

class KIBotNachricht extends Component<NachrichtProps> {

    render() {
        return (
            <React.Fragment>
                <div className="kibot-zeile kibot-zeile--frage">
                    <div className="kibot-frage">{this.props.runde.frage}</div>
                </div>
                {this.antwortTeil()}
            </React.Fragment>
        );
    }

    antwortTeil() {
        const r = this.props.runde;

        if (r.fehler) {
            return (
                <div className="kibot-zeile">
                    <span className="kibot-avatar kibot-avatar--klein"><KIBotLogo groesse={19} /></span>
                    <div className="kibot-fehler" role="alert">
                        <b>Die Antwort konnte nicht geladen werden.</b>
                        <span>{r.fehler}</span>
                        <button type="button" onClick={() => this.props.onErneutSenden(this.props.index)}>Erneut senden</button>
                    </div>
                </div>
            );
        }

        // Antwort ist noch unterwegs: Logo mit Welle und ein Satz dazu
        if (r.antwort === undefined) {
            return (
                <div className="kibot-zeile kibot-warten">
                    <KIBotLogo art="arbeitet" groesse={28} />
                    <span className="kibot-warten-text">{this.props.botName} {this.props.wartetext}</span>
                </div>
            );
        }

        // Mit Tabelle oder Diagramm nutzt die Antwort die ganze Breite
        const mitDaten = !!r.bloecke && r.bloecke.some(b => b.typ !== "text");

        return (
            <React.Fragment>
                <div className="kibot-zeile">
                    <span className="kibot-avatar kibot-avatar--klein"><KIBotLogo groesse={19} /></span>
                    <div className={"kibot-antwort" + (mitDaten ? " kibot-antwort--daten" : "")}>
                        {this.formatiere(r.antwort)}
                        {r.bloecke && <KIDatenBloecke bloecke={r.bloecke} abgefragt={r.abgefragt} />}
                        {this.metaTeil()}
                        {this.vorschlagTeil()}
                    </div>
                </div>
                {this.aktionenTeil()}
            </React.Fragment>
        );
    }

    // Folgefragen zum Anklicken, nur unter der letzten Antwort
    vorschlagTeil() {
        const vorschlaege = this.props.runde.vorschlaege || [];
        const onVorschlag = this.props.onVorschlag;
        if (!onVorschlag || vorschlaege.length === 0)
            return null;

        return (
            <div className="kibot-beispiele">
                {vorschlaege.map(v => <button type="button" key={v} className="kibot-beispiel" onClick={() => onVorschlag(v)}>{v}</button>)}
            </div>
        );
    }

     // Kleine Knöpfe unter der Antwort: Daumen hoch und runter, Vorlesen
    aktionenTeil() {
        const r = this.props.runde;
        if (!r.historieID)
            return null;
            const id = r.historieID;
            const liest = this.props.vorlesen;

        return (
            <div className="kibot-aktionen">
                <button type="button" className={"kibot-aktion" + (r.bewertung === 1 ? " kibot-aktion--aktiv" : "")}
                    title="Hilfreich" aria-label="Hilfreich" aria-pressed={r.bewertung === 1}
                    onClick={() => this.props.onBewerten(this.props.index, 1)}>{Symbole.daumenHoch}</button>
                <button type="button" className={"kibot-aktion" + (r.bewertung === -1 ? " kibot-aktion--aktiv" : "")}
                    title="Nicht hilfreich" aria-label="Nicht hilfreich" aria-pressed={r.bewertung === -1}
                    onClick={() => this.props.onBewerten(this.props.index, -1)}>{Symbole.daumenRunter}</button>
                    <button type="button" className={"kibot-aktion" + (liest ? " kibot-aktion--aktiv" : "")}
                    title={liest ? "Vorlesen beenden" : "Vorlesen"} aria-label={liest ? "Vorlesen beenden" : "Vorlesen"} aria-pressed={liest}
                    onClick={() => this.props.onVorlesen(id)}>{liest ? Symbole.stopp : Symbole.lautsprecher}</button>
            </div>
        );
    }

    // Quellen und Sicherheit unter der Antwort
    metaTeil() {
        const quellen = this.props.runde.quellen || [];
        const c = this.props.runde.confidence || 0;

        if (quellen.length === 0 && c <= 0)
            return null;

        // Stufen passend zum Backend: ohne ausreichenden Kontext höchstens 60, ohne Quelle höchstens 40
        const stufe = c >= 80 ? "hoch" : c >= 60 ? "mittel" : "niedrig";

        return (
            <div className="kibot-meta">
                {quellen.length > 0 && <div className="kibot-beschriftung">Quellen</div>}
                {quellen.map(q => (
                    <div className="kibot-quelle" key={q.number}>
                        <button type="button" className="kibot-dokument" title="Als PDF in neuem Tab öffnen" onClick={() => this.props.onDokument(q, false)}>
                            {Symbole.dokument}
                            <span className="kibot-marke">{q.number}</span>
                            <span className="kibot-dokument-name">{dokumentName(q)}</span>
                        </button>
                        <button type="button" className="kibot-download" title="Als PDF herunterladen" aria-label={dokumentName(q) + " als PDF herunterladen"} onClick={() => this.props.onDokument(q, true)}>
                            {Symbole.download}
                        </button>
                    </div>
                ))}
                {c > 0 &&
                    <div className={"kibot-sicherheit kibot-sicherheit--" + stufe} title="Wie gut die Antwort durch die Handbücher belegt ist, von 0 bis 100">
                        <span className="kibot-beschriftung">Sicherheit</span>
                        <span className="kibot-balken"><i style={{ width: c + "%" }} /></span>
                        <span className="kibot-stufe">{stufe}</span>
                        <span className="kibot-wert">{c}</span>
                    </div>}
            </div>
        );
    }

   
    // Antworttext aufbereiten.

    // Bildmarkierungen [Bild Pfad="..."] herauslösen, der Rest ist Text
    formatiere(text: string): React.ReactNode[] {
        const teile = text.replace(/\[\/Bild\]/gi, "").split(/\[Bild\s+Pfad="([^"]+)"\]/i);
        let ergebnis: React.ReactNode[] = [];

        teile.forEach((teil, i) => {
            // Durch die Klammer im Suchmuster steht der Bildpfad immer an den ungeraden Stellen
            if (i % 2 === 1) {
                ergebnis.push(
                    <KIBotBild key={"bild" + i} pfad={teil} apiUrl={this.props.apiUrl} token={this.props.token}
                        erneuereToken={this.props.erneuereToken} onGrossansicht={this.props.onGrossansicht} />);
            }
            else {
                ergebnis = ergebnis.concat(this.bloecke(teil, "t" + i));
            }
        });

        return ergebnis;
    }

    // Absätze und Listen
    bloecke(text: string, schluessel: string): React.ReactNode[] {
        const ergebnis: React.ReactNode[] = [];
        let absatz: string[] = [];
        let liste: { nummer?: number, text: string }[] = [];
        let listenArt = "";

        const absatzZu = () => {
            if (absatz.length === 0) return;
            const zeilen = absatz;
            ergebnis.push(
                <p key={schluessel + "-" + ergebnis.length}>
                    {zeilen.map((z, j) => <React.Fragment key={j}>{j > 0 && <br />}{this.zeile(z)}</React.Fragment>)}
                </p>);
            absatz = [];
        };

        const listeZu = () => {
            if (liste.length === 0) return;
            // value übernimmt die Nummer aus dem Text, auch wenn ein Bild die Liste unterbrochen hat
            const punkte = liste.map((p, j) => <li key={j} value={p.nummer}>{this.zeile(p.text)}</li>);
            ergebnis.push(listenArt === "ol"
                ? <ol key={schluessel + "-" + ergebnis.length}>{punkte}</ol>
                : <ul key={schluessel + "-" + ergebnis.length}>{punkte}</ul>);
            liste = [];
            listenArt = "";
        };

        text.split("\n").forEach(z => {
            if (z.trim() === "") {
                absatzZu();
                listeZu();
                return;
            }

            const nummeriert = z.match(/^\s*(\d+)\.\s+(.*)$/);
            if (nummeriert) {
                absatzZu();
                if (listenArt === "ul") listeZu();
                listenArt = "ol";
                liste.push({ nummer: parseInt(nummeriert[1], 10), text: nummeriert[2] });
                return;
            }

            const aufzaehlung = z.match(/^\s*[-•]\s+(.*)$/);
            if (aufzaehlung) {
                absatzZu();
                if (listenArt === "ol") listeZu();
                listenArt = "ul";
                liste.push({ text: aufzaehlung[1] });
                return;
            }

            listeZu();
            absatz.push(z);
        });

        absatzZu();
        listeZu();
        return ergebnis;
    }

    // **fett** und die Quellenmarken [1]
    zeile(text: string): React.ReactNode[] {
        const quellen = this.props.runde.quellen || [];

        return text.split(/(\*\*[^*]+\*\*|\[\d+\])/g).map((t, i) => {
            if (/^\*\*[^*]+\*\*$/.test(t))
                return <strong key={i}>{t.slice(2, -2)}</strong>;

            const marke = t.match(/^\[(\d+)\]$/);
            if (marke) {
                const nr = parseInt(marke[1], 10);
                const quelle = quellen.find(q => q.number === nr);
                return quelle
                    ? <button type="button" key={i} className="kibot-marke" title={"Quelle " + nr + " öffnen"} onClick={() => this.props.onDokument(quelle, false)}>{nr}</button>
                    : <span key={i} className="kibot-marke">{nr}</span>;
            }

            return t;
        });
    }
}

// Die Liste "Meine Chats"

type VerlaufProps = {
    offen: boolean,
    chats: KSLPlusAPI.ChatUebersicht[],
    laedt: boolean,
    aktiveThreadID: string | null,
    onOeffnen: (threadID: string) => void,
    onNeu: () => void,
    onUmbenennen: (threadID: string, titel: string) => void,
    onLoeschen: (threadID: string) => void
}

type VerlaufState = {
    menue: { threadID: string, x: number, y: number, rueckfrage: boolean } | null,
    umbenennen: string | null,      // threadID des Chats, dessen Titel gerade bearbeitet wird
    neuerTitel: string
}

// "heute, 17:44" / "gestern" / "19.09." / "19.09.2025"
function datumText(d?: Date): string {
    if (!d) return "";
    const jetzt = new Date();
    const tag = (x: Date) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
    const zwei = (n: number) => (n < 10 ? "0" : "") + n;
    const tage = Math.round((tag(jetzt) - tag(d)) / 86400000);

    if (tage === 0) return "heute, " + zwei(d.getHours()) + ":" + zwei(d.getMinutes());
    if (tage === 1) return "gestern";
    return zwei(d.getDate()) + "." + zwei(d.getMonth() + 1) + "." + (d.getFullYear() !== jetzt.getFullYear() ? d.getFullYear() : "");
}

class KIBotVerlauf extends Component<VerlaufProps, VerlaufState> {
    private listeRef = React.createRef<HTMLDivElement>();
    private menueRef = React.createRef<HTMLDivElement>();
    private umbenennenId: string | null = null;

    constructor(props: VerlaufProps) {
        super(props);
        this.state = { menue: null, umbenennen: null, neuerTitel: "" };
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.aussenKlick);
        document.addEventListener("keydown", this.taste);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.aussenKlick);
        document.removeEventListener("keydown", this.taste);
    }

    componentDidUpdate(prevProps: VerlaufProps) {
        // Liste wurde zugeklappt: offenes Menü schließen
        if (prevProps.offen && !this.props.offen && (this.state.menue || this.state.umbenennen)) {
            this.umbenennenId = null;
            this.setState({ menue: null, umbenennen: null });
        }
    }

    // Klick irgendwo anders schließt das Menü
    aussenKlick = (e: MouseEvent) => {
        if (!this.state.menue) return;
        const ziel = e.target as Element;
        if (this.menueRef.current && this.menueRef.current.contains(ziel)) return;
        if (ziel.closest && ziel.closest(".kibot-punkte")) return;
        this.setState({ menue: null });
    }

    taste = (e: KeyboardEvent) => {
        if (e.key === "Escape" && this.state.menue)
            this.setState({ menue: null });
    }

    menueOeffnen = (threadID: string, clientX: number, clientY: number) => {
        const liste = this.listeRef.current;
        if (!liste) return;
        const r = liste.getBoundingClientRect();
        const x = Math.max(6, Math.min(clientX - r.left, r.width - 182));
        const y = Math.max(6, Math.min(clientY - r.top, r.height - 140));
        this.setState({ menue: { threadID: threadID, x: x, y: y, rueckfrage: false } });
    }

    umbenennenStarten = (threadID: string, titel: string) => {
        this.umbenennenId = threadID;
        this.setState({ menue: null, umbenennen: threadID, neuerTitel: titel });
    }

    umbenennenFertig = (speichern: boolean) => {
        // Enter und das anschließende Verlassen des Feldes dürfen nur einmal speichern
        const id = this.umbenennenId;
        if (!id) return;
        this.umbenennenId = null;

        const titel = this.state.neuerTitel.replace(/\s+/g, " ").trim();
        const chat = this.props.chats.find(c => c.threadID === id);
        this.setState({ umbenennen: null });

        if (speichern && titel !== "" && (!chat || chat.titel !== titel))
            this.props.onUmbenennen(id, titel);
    }

    render() {
        const anzahl = this.props.chats.length;

        return (
            <div className={"kibot-liste" + (this.props.offen ? " kibot-liste--offen" : "")} ref={this.listeRef} aria-label="Meine Chats">
                <div className="kibot-liste-kopf">
                    <b>Meine Chats</b>
                    <span>{anzahl >= 30 ? "die letzten 30" : ""}</span>
                </div>
                <button type="button" className="kibot-neu" onClick={this.props.onNeu}>{Symbole.neu}Neuer Chat</button>
                <div className="kibot-liste-inhalt">
                    {anzahl === 0 && <div className="kibot-hinweis">{this.props.laedt ? "Chats werden geladen …" : "Noch keine Chats."}</div>}
                    {this.props.chats.map(c => this.eintrag(c))}
                </div>
                {this.menue()}
            </div>
        );
    }

    eintrag(c: KSLPlusAPI.ChatUebersicht) {
        const id = c.threadID || "";
        const klasse = "kibot-eintrag" + (id === this.props.aktiveThreadID ? " kibot-eintrag--aktiv" : "");

        // Titel wird gerade umbenannt: Eingabefeld statt Text
        if (id === this.state.umbenennen) {
            return (
                <div key={id} className={klasse}>
                    <input type="text" autoFocus maxLength={100} value={this.state.neuerTitel} aria-label="Neuer Titel für den Chat"
                        onChange={e => this.setState({ neuerTitel: e.target.value })}
                        onKeyDown={e => {
                            if (e.key === "Enter") this.umbenennenFertig(true);
                            else if (e.key === "Escape") this.umbenennenFertig(false);
                        }}
                        onBlur={() => this.umbenennenFertig(true)} />
                </div>
            );
        }

        const menueOffen = this.state.menue !== null && this.state.menue.threadID === id;

        return (
            <div key={id} className={klasse} role="button" tabIndex={0}
                onClick={() => this.props.onOeffnen(id)}
                onKeyDown={e => { if (e.key === "Enter") this.props.onOeffnen(id); }}
                onContextMenu={e => { e.preventDefault(); this.menueOeffnen(id, e.clientX, e.clientY); }}>
                <span className="kibot-eintrag-titel">{c.titel}</span>
                <span className="kibot-eintrag-datum">{datumText(c.letzteAktivitaet)}</span>
                <button type="button" className={"kibot-punkte" + (menueOffen ? " kibot-punkte--offen" : "")}
                    aria-label={"Aktionen für " + (c.titel || "Chat")} aria-haspopup="true" aria-expanded={menueOffen}
                    onClick={e => {
                        e.stopPropagation();
                        if (menueOffen) {
                            this.setState({ menue: null });
                        }
                        else {
                            const r = e.currentTarget.getBoundingClientRect();
                            this.menueOeffnen(id, r.right - 176, r.bottom + 4);
                        }
                    }}>
                    {Symbole.punkte}
                </button>
            </div>
        );
    }

    menue() {
        const m = this.state.menue;
        if (!m) return null;

        const chat = this.props.chats.find(c => c.threadID === m.threadID);
        const titel = chat && chat.titel ? chat.titel : "";

        return (
            <div className="kibot-menue" role="menu" ref={this.menueRef} style={{ left: m.x, top: m.y }}>
                {!m.rueckfrage &&
                    <React.Fragment>
                        <button type="button" role="menuitem" onClick={() => this.umbenennenStarten(m.threadID, titel)}>{Symbole.stift}Umbenennen</button>
                        <button type="button" role="menuitem" className="kibot-rot" onClick={() => this.setState({ menue: { threadID: m.threadID, x: m.x, y: m.y, rueckfrage: true } })}>{Symbole.eimer}Löschen</button>
                    </React.Fragment>}
                {m.rueckfrage &&
                    <React.Fragment>
                        <div className="kibot-menue-frage">Chat <strong>»{titel}«</strong> löschen? Das lässt sich nicht rückgängig machen.</div>
                        <div className="kibot-menue-zeile">
                            <button type="button" onClick={() => this.setState({ menue: null })}>Abbrechen</button>
                            <button type="button" className="kibot-loeschen" onClick={() => { this.setState({ menue: null }); this.props.onLoeschen(m.threadID); }}>Löschen</button>
                        </div>
                    </React.Fragment>}
            </div>
        );
    }
}

// Der Bot selbst: Knopf, Fenster, Zustand, alle Aufrufe an die API


type Props = {
    apiUrl: string,
    token: () => string,
    refreshTokens: () => Promise<KSLPlusAPI.LoginResponse | null>,
    app: string,                    // "Admin", später der Wert für die Visualisierung
    thema?: string,                 // "Doppik" oder "Kameralistik", leer = alle Handbücher
    subthema?: string,                 // "Haushaltsplanung", "Jahresrechnung" oder "UBW", leer = alle Handbücher
    botName?: string,               // Standard "Paul"
    beispielFragen?: string[],
    hinweis?: string,
    rahmen?: DatenRahmen            // gesetzt: Fragen gehen an den Datenassistenten (Zahlen und Handbuch)
}

type State = {
    offen: boolean,                             // Fenster oder nur der runde Knopf
    anker: { rechts: number, unten: number },   // ein Punkt für Knopf und Fenster (Abstand zum Rand)
    breite: number,
    hoehe: number,
    maximiert: boolean,
    knopfZieht: boolean,
    listeOffen: boolean,
    chats: KSLPlusAPI.ChatUebersicht[],
    chatsLaden: boolean,
    threadID: string | null,                    // null = neuer Chat
    titel: string,
    runden: Runde[],
    begruessung: boolean,                       // Begrüßung oben anzeigen (nur bei neuen Chats)
    chatLaedt: boolean,                         // ein alter Chat wird geöffnet
    wartet: boolean,                            // eine Antwort ist unterwegs
    wartetext: string,
    eingabe: string,
    ungelesen: number,                          // die rote Zahl
    grossesBild: string | null,                 // was die Großansicht zeigt
    bildZoom: boolean,                          // Großansicht hineingezoomt
    blase: boolean,                             // Sprechblase am Knopf sichtbar
    neuerChatNr: number,                        // spielt die Aufbau-Animation neu ab
    hoert: boolean,                             // Mikrofon ist an
    bereit: boolean,                            // Azure hört wirklich zu, ab jetzt kommt alles Gesprochene an
    zwischentext: string,                       // was gerade gesprochen wird, noch nicht fertig erkannt
    sprachFehler: string | null,                // Hinweis über der Eingabe, wenn Sprache nicht geht
    vorlesen: number | null                     // historieID der Antwort, die gerade vorgelesen wird
}

type ZiehArt = "knopf" | "kopf" | "griff";

const RAND = 8;              // Mindestabstand zum Rand des Browserfensters
const KNOPF = 56;            // Größe des runden Knopfs
const MIN_BREITE = 320;
const MIN_HOEHE = 380;
const SPEICHER = "KIBot_Lage";
const WARTETEXTE = ["sucht in den Handbüchern …", "formuliert die Antwort …"];
const WARTETEXTE_DATEN = ["sucht in den Daten und Handbüchern …", "formuliert und prüft die Antwort …"];
const BLASE = "KIBot_Hinweis";      // Sprechblase in dieser Anmeldung schon gezeigt
const KENNUNG = "KIBot_Browser";    // Kennung dieses Browsers für Chats ohne Anmeldung (localStorage)
const KENNUNG_HEADER = "X-KIBot-Browser";

function begrenze(wert: number, min: number, max: number): number {
    return Math.max(min, Math.min(wert, max));
}
// Kam die Sprechblase in dieser Anmeldung schon? Der sessionStorage bleibt bei F5 und Gemeindewechsel erhalten,
// ist nach dem Schließen des Browsers leer und wird beim Abmelden gelöscht (App.tsx, handleLogout).
// Geht der Speicher nicht, lieber gar nicht zeigen.
function blaseGezeigt(): boolean {
    try {
        return window.sessionStorage.getItem(BLASE) === "1";
    }
    catch (e) {
        return true;
    }
}

function blaseMerken() {
    try {
        window.sessionStorage.setItem(BLASE, "1");
    }
    catch (e) {
        // dann kommt sie eben noch einmal
    }
}
// Ohne Anmeldung: zufällige Kennung dieses Browsers, damit der Server die Chats zuordnen kann ("Meine Chats").
// Angelegt wird sie erst mit der ersten Frage. Geht der Speicher nicht, gibt es ohne Anmeldung keine Liste.
function browserKennung(anlegen: boolean): string | null {
    try {
        let kennung = window.localStorage.getItem(KENNUNG);
        if (!kennung && anlegen) {
            kennung = neueKennung();
            window.localStorage.setItem(KENNUNG, kennung);
        }
        return kennung;
    }
    catch (e) {
        return null;
    }
}

// Zufällige GUID (Version 4)
function neueKennung(): string {
    const b = new Uint8Array(16);
    window.crypto.getRandomValues(b);
    b[6] = (b[6] & 0x0f) | 0x40;
    b[8] = (b[8] & 0x3f) | 0x80;
    const h = Array.from(b, x => (x < 16 ? "0" : "") + x.toString(16)).join("");
    return h.substr(0, 8) + "-" + h.substr(8, 4) + "-" + h.substr(12, 4) + "-" + h.substr(16, 4) + "-" + h.substr(20, 12);
}

// fetch für den API-Client: schickt die Kennung des Browsers mit, wenn es eine gibt.
// Der Server nimmt sie nur, wenn niemand angemeldet ist.
function fetchMitKennung(url: RequestInfo, init?: RequestInit): Promise<Response> {
    const kennung = browserKennung(false);
    if (!kennung)
        return window.fetch(url, init);

    const headers = new Headers(init ? init.headers : undefined);
    headers.set(KENNUNG_HEADER, kennung);
    return window.fetch(url, Object.assign({}, init, { headers: headers }));
}
// Position und Größe aus dem Browser lesen (falls schon einmal gespeichert)
function gespeicherteLage() {
    const lage = { rechts: 24, unten: 24, breite: 400, hoehe: 560 };
    try {
        const text = window.localStorage.getItem(SPEICHER);
        if (text) {
            const w = JSON.parse(text);
            if (typeof w.rechts === "number") lage.rechts = w.rechts;
            if (typeof w.unten === "number") lage.unten = w.unten;
            if (typeof w.breite === "number") lage.breite = w.breite;
            if (typeof w.hoehe === "number") lage.hoehe = w.hoehe;
        }
    }
    catch (e) {
        // Ohne gespeicherte Lage geht es einfach mit den Standardwerten weiter
    }
    return lage;
}

export class KIBot extends Component<Props, State> {
    private aktiv = true;
    private zug: { art: ZiehArt, x: number, y: number, bewegt: boolean, rechts: number, unten: number, breite: number, hoehe: number } | null = null;
    private tokenErneuerung: Promise<boolean> | null = null;
    private wartetextTimer = 0;
    private nachrichtenRef = React.createRef<HTMLDivElement>();
    private eingabeRef = React.createRef<HTMLTextAreaElement>();
    private bildRahmen: DOMRect | null = null;      // Lage des Bildes vor dem Zoomen
    private blaseTimer = 0;
    private sprachZugang: SprachZugang | null = null;      // zuletzt geholtes Token für Azure Speech
    private erkenner: sdk.SpeechRecognizer | null = null;  // läuft, solange das Mikrofon an ist
    private sprachTimer = 0;                                // erneuert das Token während des Zuhörens
    private vorleser: AudioBufferSourceNode | null = null;  // spielt die Antwort ab, die gerade vorgelesen wird

    constructor(props: Props) {
        super(props);
        const lage = gespeicherteLage();
        this.state = {
            offen: false,
            anker: this.klemmeAnker(lage.rechts, lage.unten),
            breite: lage.breite,
            hoehe: lage.hoehe,
            maximiert: false,
            knopfZieht: false,
            listeOffen: false,
            chats: [],
            chatsLaden: false,
            threadID: null,
            titel: "",
            runden: [],
            begruessung: true,
            chatLaedt: false,
            wartet: false,
            wartetext: WARTETEXTE[0],
            eingabe: "",
            ungelesen: 0,
            grossesBild: null,
            bildZoom: false,
            blase: false,
            neuerChatNr: 0,
            hoert: false,
            bereit: false,
            zwischentext: "",
            sprachFehler: null,
            vorlesen: null
        };
    }

    componentDidMount() {
        window.addEventListener("resize", this.browserGroesse);
        document.addEventListener("keydown", this.taste);
        // Sprechblase: 3 Sekunden nach dem Laden, 15 Sekunden lang, einmal pro Anmeldung
        if (this.props.hinweis && !blaseGezeigt()) {
            this.blaseTimer = window.setTimeout(() => {
                if (this.state.offen) return;
                blaseMerken();
                this.setState({ blase: true });
                this.blaseTimer = window.setTimeout(() => this.setState({ blase: false }), 15000);
            }, 3000);
        }
    }

    componentWillUnmount() {
        this.aktiv = false;
        window.clearTimeout(this.wartetextTimer);
        window.clearTimeout(this.blaseTimer);
        window.removeEventListener("resize", this.browserGroesse);
        document.removeEventListener("keydown", this.taste);
        // Mikrofon aus und Vorlesen beenden, wenn der Bot verschwindet (z. B. Gemeindewechsel)
        this.zuhoerenStoppen(false);
        this.vorlesenStoppen();
    }


    // Anmeldung: Aufrufe an die API mit Token

    client() {
        return new KSLPlusAPI.Ai_Client(this.props.apiUrl, { fetch: fetchMitKennung });
    }

    // Mehrere Anfragen können gleichzeitig mit 401 zurückkommen (z. B. mehrere Bilder).
    // Das Token soll trotzdem nur einmal erneuert werden.
    erneuereToken = (): Promise<boolean> => {
        if (!this.tokenErneuerung) {
            this.tokenErneuerung = this.props.refreshTokens()
                .then(antwort => antwort !== null)
                .catch(() => false)
                .then(ok => {
                    this.tokenErneuerung = null;
                    return ok;
                });
        }
        return this.tokenErneuerung;
    }

    // Führt einen Aufruf aus. Bei 401 wird das Token erneuert und der Aufruf einmal wiederholt.
    mitToken<T>(aufruf: (token: string) => Promise<T>): Promise<T> {
        return aufruf(this.props.token()).catch(Reason => {
            if (Reason && Reason.status == 401) {
                return this.erneuereToken().then(ok => {
                    if (!ok) throw Reason;
                    return aufruf(this.props.token());
                });
            }
            throw Reason;
        });
    }

    
    // Position, Ziehen, Größe
    

    klemmeAnker(rechts: number, unten: number) {
        return {
            rechts: begrenze(rechts, RAND, window.innerWidth - KNOPF - RAND),
            unten: begrenze(unten, RAND, window.innerHeight - KNOPF - RAND)
        };
    }

    // Wo das Fenster steht und wie groß es ist, immer innerhalb des Browserfensters
    fensterBox() {
        const W = window.innerWidth;
        const H = window.innerHeight;

        if (this.state.maximiert)
            return { rechts: RAND, unten: RAND, breite: W - 2 * RAND, hoehe: H - 2 * RAND };

        const breite = Math.min(this.state.breite, W - 2 * RAND);
        const hoehe = Math.min(this.state.hoehe, H - 2 * RAND);
        return {
            rechts: begrenze(this.state.anker.rechts, RAND, W - breite - RAND),
            unten: begrenze(this.state.anker.unten, RAND, H - hoehe - RAND),
            breite: breite,
            hoehe: hoehe
        };
    }

    speichern() {
        try {
            window.localStorage.setItem(SPEICHER, JSON.stringify({
                rechts: this.state.anker.rechts,
                unten: this.state.anker.unten,
                breite: this.state.breite,
                hoehe: this.state.hoehe
            }));
        }
        catch (e) {
            // Speichern ist nur eine Annehmlichkeit
        }
    }

    browserGroesse = () => {
        this.setState({ anker: this.klemmeAnker(this.state.anker.rechts, this.state.anker.unten) });
    }

    ziehStart = (art: ZiehArt) => (e: React.PointerEvent<HTMLElement>) => {
        if (e.button !== 0) return;
        // Die Knöpfe im Kopf sollen Knöpfe bleiben
        if (art === "kopf" && (e.target as Element).closest("button")) return;
        if (art !== "knopf" && this.state.maximiert) return;

        const f = this.fensterBox();
        this.zug = {
            art: art, x: e.clientX, y: e.clientY, bewegt: false,
            rechts: art === "knopf" ? this.state.anker.rechts : f.rechts,
            unten: art === "knopf" ? this.state.anker.unten : f.unten,
            breite: f.breite,
            hoehe: f.hoehe
        };
        e.currentTarget.setPointerCapture(e.pointerId);
        e.preventDefault();
    }

    ziehBewegung = (e: React.PointerEvent<HTMLElement>) => {
        const z = this.zug;
        if (!z) return;

        const dx = e.clientX - z.x;
        const dy = e.clientY - z.y;

        // Erst ab 5 Pixel Bewegung gilt es als Ziehen, darunter ist es ein Klick
        if (!z.bewegt) {
            if (Math.abs(dx) + Math.abs(dy) < 5) return;
            z.bewegt = true;
            if (z.art === "knopf") this.setState({ knopfZieht: true });
        }

        const W = window.innerWidth;
        const H = window.innerHeight;

        if (z.art === "knopf") {
            this.setState({ anker: this.klemmeAnker(z.rechts - dx, z.unten - dy) });
        }
        else if (z.art === "kopf") {
            this.setState({
                anker: {
                    rechts: begrenze(z.rechts - dx, RAND, W - z.breite - RAND),
                    unten: begrenze(z.unten - dy, RAND, H - z.hoehe - RAND)
                }
            });
        }
        else {
            // Griff oben links: die Ecke unten rechts bleibt stehen
            this.setState({
                breite: begrenze(z.breite - dx, MIN_BREITE, W - z.rechts - RAND),
                hoehe: begrenze(z.hoehe - dy, MIN_HOEHE, H - z.unten - RAND),
                anker: { rechts: z.rechts, unten: z.unten }
            });
        }
    }

    ziehEnde = () => {
        const z = this.zug;
        this.zug = null;
        if (!z) return;

        if (z.art === "knopf" && !z.bewegt) {
            this.oeffnen();
            return;
        }
        if (this.state.knopfZieht) this.setState({ knopfZieht: false });
        this.speichern();
    }

    kopfDoppelklick = (e: React.MouseEvent<HTMLElement>) => {
        if ((e.target as Element).closest("button")) return;
        this.setState({ maximiert: !this.state.maximiert });
    }


    
    // Öffnen, Zuklappen, Tasten
    

    oeffnen = () => {
        this.blaseWeg();
        // Token für die Sprache schon jetzt holen, dann startet das Mikrofon beim Klick schneller
        if (SPRACHE_MOEGLICH) this.holeSprachToken(false).catch(() => { /* wird beim Klick erneut versucht */ });
        this.setState({ offen: true, ungelesen: 0 }, () => {
            this.fokusEingabe();
            this.zurLetztenFrage();
        });
    }

    zuklappen = () => {
        if (this.state.hoert) this.zuhoerenStoppen(false);
        this.vorlesenStoppen();
        this.setState({ offen: false, listeOffen: false, knopfZieht: false });
    }

    // Wer den Bot geöffnet oder die Sprechblase weggeklickt hat, sieht sie erst bei der nächsten Anmeldung wieder
    blaseWeg = () => {
        window.clearTimeout(this.blaseTimer);
        blaseMerken();
        if (this.state.blase) this.setState({ blase: false });
    }

    // Die Sprechblase steht neben dem Knopf, immer zur Bildschirmmitte hin, damit sie nicht aus dem Bild ragt.
    // Die Klassen sagen dem CSS, an welcher Seite der Pfeil zum Knopf sitzt.
    blaseLage() {
        const W = window.innerWidth;
        const H = window.innerHeight;
        const a = this.state.anker;
        const stil: React.CSSProperties = {};
        let klasse = "kibot-blase";

        if (a.rechts + KNOPF / 2 < W / 2) { stil.right = a.rechts; klasse += " kibot-blase--rechts"; }
        else { stil.left = W - a.rechts - KNOPF; klasse += " kibot-blase--links"; }

        if (a.unten + KNOPF / 2 < H / 2) { stil.bottom = a.unten + KNOPF + 10; klasse += " kibot-blase--oben"; }
        else { stil.top = H - a.unten + 10; klasse += " kibot-blase--unten"; }

        return { stil: stil, klasse: klasse };
    }

    taste = (e: KeyboardEvent) => {
        if (e.key === "Escape" && this.state.grossesBild)
            this.setState({ grossesBild: null });
    }

    // Großansicht: ein Klick zoomt an dieser Stelle hinein, der nächste wieder heraus
    bildKlick = (e: React.MouseEvent<HTMLImageElement>) => {
        e.stopPropagation();        // sonst schließt der Klick die Großansicht
        if (!this.state.bildZoom)
            this.bildRahmen = e.currentTarget.getBoundingClientRect();
        this.zoomPunkt(e);
        this.setState({ bildZoom: !this.state.bildZoom });
    }

    // Beim Zoomen folgt der sichtbare Ausschnitt der Maus
    zoomPunkt = (e: React.MouseEvent<HTMLImageElement>) => {
        const r = this.bildRahmen;
        if (!r) return;
        const x = begrenze((e.clientX - r.left) / r.width * 100, 0, 100);
        const y = begrenze((e.clientY - r.top) / r.height * 100, 0, 100);
        e.currentTarget.style.transformOrigin = x + "% " + y + "%";
    }    

    fokusEingabe = () => {
        if (this.eingabeRef.current) this.eingabeRef.current.focus();
    }

    nachUnten = () => {
        const n = this.nachrichtenRef.current;
        if (n) n.scrollTop = n.scrollHeight;
    }

    // Zur letzten Frage springen, damit man die Antwort von oben lesen kann
    zurLetztenFrage = () => {
        const n = this.nachrichtenRef.current;
        if (!n) return;
        const fragen = n.querySelectorAll(".kibot-zeile--frage");
        const letzte = fragen.length > 0 ? fragen[fragen.length - 1] as HTMLElement : null;
        n.scrollTop = letzte ? Math.max(0, letzte.offsetTop - 12) : 0;
    }


    // Fragen und Antworten
    

    eingabeGeaendert = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        this.setState({ eingabe: e.target.value });
        // Das Feld wächst mit, bis zu vier Zeilen
        const feld = e.target;
        feld.style.height = "38px";
        feld.style.height = Math.min(Math.max(38, feld.scrollHeight + 2), 96) + "px";
    }

    eingabeTaste = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        // Enter schickt ab, Umschalt+Enter macht eine neue Zeile
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            this.senden(this.state.eingabe);
        }
    }

    senden = (text: string) => {
        const frage = text.trim();
        if (frage === "" || this.state.wartet) return;
         // Mikrofon aus, damit nach dem Senden kein Text mehr ins leere Feld rutscht
        if (this.state.hoert) this.zuhoerenStoppen(false);
        const nr = this.state.runden.length;
        const wartetexte = this.props.rahmen ? WARTETEXTE_DATEN : WARTETEXTE;
        this.setState({
            runden: this.state.runden.concat([{ frage: frage }]),
            wartet: true,
            wartetext: wartetexte[0],
            eingabe: "",
            listeOffen: false
        }, this.nachUnten);

        if (this.eingabeRef.current) this.eingabeRef.current.style.height = "38px";

        // Nach vier Sekunden wechselt der Satz unter dem Logo
        window.clearTimeout(this.wartetextTimer);
        this.wartetextTimer = window.setTimeout(() => {
            if (this.aktiv) this.setState({ wartetext: wartetexte[1] });
        }, 4000);

        // Ohne Anmeldung: Kennung des Browsers anlegen, damit der Chat unter "Meine Chats" erscheint
        if (!this.props.token()) browserKennung(true);
        this.stelleFrage(nr, frage);
    }

    stelleFrage(nr: number, frage: string) {
        if (this.props.rahmen) {
            this.stelleDatenFrage(nr, frage, this.props.rahmen);
            return;
        }
        const anfrage = new KSLPlusAPI.KSLPlusAskRequest({
            threadID: this.state.threadID || undefined,
            frage: frage,
            thema: this.props.thema,
            subThema: this.props.subthema,
            app: this.props.app
        });

        this.mitToken(token => this.client().ask(token, anfrage))
            .then(antwort => this.antwortErhalten(nr, antwort))
            .catch(Reason => this.frageFehlgeschlagen(nr, frage, Reason));
    }
     // Datenassistent: Frage mit dem geöffneten Plan; die früheren Fragen des Chats liest der Server selbst
    stelleDatenFrage(nr: number, frage: string, rahmen: DatenRahmen) {
        const anfrage = new KSLPlusAPI.DatenFrageRequest({ ...rahmen, threadID: this.state.threadID || undefined, frage: frage });

        this.mitToken(token => this.client().daten(token, anfrage))
            .then(antwort => this.datenAntwortErhalten(nr, antwort))
            .catch(Reason => this.datenFrageFehlgeschlagen(nr, frage, Reason));
    }

    datenAntwortErhalten(nr: number, antwort: KSLPlusAPI.DatenFrageAntwort) {
        window.clearTimeout(this.wartetextTimer);
        if (!this.aktiv) return;

        const bloecke = antwort.bloecke || [];
        const runden = this.state.runden.slice();
        runden[nr] = {
            frage: runden[nr].frage,
            antwort: bloecke.filter(b => b.typ === "text").map(b => b.inhalt || "").join("\n\n"),
            // Gleiche Form wie beim Handbuch-Bot: [1], [2] im Text und das Öffnen als PDF funktionieren wie dort
            quellen: (antwort.quellen || []).map(q => new KSLPlusAPI.RagSource({ number: q.nummer, title: q.titel, source: q.quelle })),
            historieID: antwort.historieID,
            bloecke: bloecke,
            abgefragt: antwort.abgefragt || [],
            vorschlaege: antwort.vorschlaege || []
        };

        this.setState({
            runden: runden,
            wartet: false,
            threadID: antwort.threadID || this.state.threadID,
            titel: antwort.titel || this.state.titel,
            ungelesen: this.state.offen ? this.state.ungelesen : this.state.ungelesen + 1
        }, () => {
            if (this.state.offen) this.zurLetztenFrage();
        });
    }

    datenFrageFehlgeschlagen(nr: number, frage: string, Reason: any) {
        window.clearTimeout(this.wartetextTimer);
        if (!this.aktiv) return;

        const status = Reason ? Reason.status : 0;

        // 404 bei einem bestehenden Chat: gelöscht oder ohne Anmeldung abgelaufen. Dann als neuen Chat stellen.
        if (status == 404 && this.state.threadID !== null) {
            this.setState({ threadID: null, titel: "" }, () => this.stelleFrage(nr, frage));
            return;
        }

        const runden = this.state.runden.slice();
        runden[nr] = {
            frage: frage,
            fehler: status == 401 ? "Dieser Plan ist noch nicht veröffentlicht. Bitte melden Sie sich an."
                : status == 404 ? "Der Datenassistent ist für diesen Plan nicht eingeschaltet."
                : "Der Dienst ist gerade nicht erreichbar."
        };
        this.setState({ runden: runden, wartet: false });
    }

    antwortErhalten(nr: number, antwort: KSLPlusAPI.RagAnswer) {
        window.clearTimeout(this.wartetextTimer);
        if (!this.aktiv) return;

        const runden = this.state.runden.slice();
        runden[nr] = {
            frage: runden[nr].frage,
            antwort: antwort.answer || "",
            confidence: antwort.confidence,
            quellen: antwort.sources || [],
            historieID: antwort.historieID
        };

        this.setState({
            runden: runden,
            wartet: false,
            threadID: antwort.threadID || this.state.threadID,
            titel: antwort.titel || this.state.titel,
            // Fenster zu: die rote Zahl zählt hoch
            ungelesen: this.state.offen ? this.state.ungelesen : this.state.ungelesen + 1
        }, () => {
            if (this.state.offen) this.zurLetztenFrage();
        });
    }

    frageFehlgeschlagen(nr: number, frage: string, Reason: any) {
        window.clearTimeout(this.wartetextTimer);
        if (!this.aktiv) return;

        // 404: Der Chat wurde inzwischen gelöscht, z. B. in einem anderen Tab.
        // Dann die Frage als neuen Chat stellen.
        if (Reason && Reason.status == 404 && this.state.threadID !== null) {
            this.setState({ threadID: null, titel: "" }, () => this.stelleFrage(nr, frage));
            return;
        }

        const runden = this.state.runden.slice();
        runden[nr] = { frage: frage, fehler: "Der Dienst ist gerade nicht erreichbar." };
        this.setState({ runden: runden, wartet: false });
    }
    // Daumen hoch oder runter. Ein zweiter Klick auf denselben Daumen nimmt die Bewertung zurück.
    bewerten = (index: number, wert: number) => {
        const runde = this.state.runden[index];
        if (!runde || !runde.historieID) return;

        const id = runde.historieID;
        const vorher = runde.bewertung || 0;
        const neu = vorher === wert ? 0 : wert;

        // Sofort anzeigen, im Hintergrund speichern. Klappt das Speichern nicht, den alten Stand zurückholen.
        this.setzeBewertung(id, neu);
        this.mitToken(token => this.client().bewerten(id, neu, this.state.threadID || undefined, token))
            .catch(() => { if (this.aktiv) this.setzeBewertung(id, vorher); });
    }

    // Über die ID statt die Position, falls inzwischen ein anderer Chat offen ist
    setzeBewertung(id: number, wert: number) {
        this.setState({
            runden: this.state.runden.map(r => r.historieID === id ? { ...r, bewertung: wert || undefined } : r)
        });
    }
    erneutSenden = (index: number) => {
        const runde = this.state.runden[index];
        if (!runde || this.state.wartet) return;

        const runden = this.state.runden.slice();
        runden.splice(index, 1);
        this.setState({ runden: runden }, () => this.senden(runde.frage));
    }


    // Chats: neu, öffnen, umbenennen, löschen

    listeUmschalten = () => {
        const offen = !this.state.listeOffen;
        this.setState({ listeOffen: offen });
        if (offen) this.ladeChats();
    }

    ladeChats = () => {
        this.setState({ chatsLaden: true });
        this.mitToken(token => this.client().chats(this.props.app, token))
            .then(chats => { if (this.aktiv) this.setState({ chats: chats || [], chatsLaden: false }); })
            .catch(() => { if (this.aktiv) this.setState({ chatsLaden: false }); });
    }

    neuerChat = () => {
        if (this.state.wartet) return;
        this.vorlesenStoppen();
        this.setState({
            threadID: null,
            titel: "",
            runden: [],
            begruessung: true,
            chatLaedt: false,
            listeOffen: false,
            neuerChatNr: this.state.neuerChatNr + 1
        }, this.fokusEingabe);
    }

    chatOeffnen = (threadID: string) => {
        if (this.state.wartet) return;
        this.vorlesenStoppen();

        const eintrag = this.state.chats.find(c => c.threadID === threadID);
        this.setState({
            threadID: threadID,
            titel: eintrag && eintrag.titel ? eintrag.titel : "",
            runden: [],
            begruessung: false,
            chatLaedt: true,
            listeOffen: false
        });

        this.mitToken(token => this.client().chat(threadID, token))
            .then(nachrichten => {
                if (!this.aktiv || this.state.threadID !== threadID) return;
                const runden: Runde[] = (nachrichten || []).map(n => ({
                    frage: n.frage || "",
                    antwort: n.answer || "",
                    confidence: n.confidence,
                    quellen: n.sources || [],
                    historieID: n.historieID,
                    bewertung: n.bewertung,
                    // Datenassistent: Tabellen, Diagramme und Abfragen der gespeicherten Antwort
                    bloecke: n.daten ? n.daten.bloecke : undefined,
                    abgefragt: n.daten ? n.daten.abgefragt : undefined,
                    vorschlaege: n.daten ? n.daten.vorschlaege : undefined
                }));
                this.setState({ runden: runden, chatLaedt: false }, this.zurLetztenFrage);
            })
            .catch(() => {
                if (!this.aktiv || this.state.threadID !== threadID) return;
                // Den Chat gibt es nicht mehr: neu anfangen und die Liste auffrischen
                this.setState({ threadID: null, titel: "", runden: [], begruessung: true, chatLaedt: false });
                this.ladeChats();
            });
    }

    umbenennen = (threadID: string, titel: string) => {
        // Sofort anzeigen, dann im Hintergrund speichern
        this.setState({
            chats: this.state.chats.map(c => c.threadID === threadID
                ? new KSLPlusAPI.ChatUebersicht({ threadID: c.threadID, titel: titel, letzteAktivitaet: c.letzteAktivitaet })
                : c),
            titel: this.state.threadID === threadID ? titel : this.state.titel
        });

        this.mitToken(token => this.client().chatUmbenennen(threadID, token, new KSLPlusAPI.ChatUmbenennenRequest({ titel: titel })))
            .catch(() => this.ladeChats());     // bei einem Fehler den echten Stand neu holen
    }

    loeschen = (threadID: string) => {
        this.setState({ chats: this.state.chats.filter(c => c.threadID !== threadID) });
        if (this.state.threadID === threadID) this.neuerChat();

        this.mitToken(token => this.client().chatLoeschen(threadID, token))
            .catch(() => this.ladeChats());
    }


    // Dokumente und Bilder
    

    dokumentOeffnen = (quelle: KSLPlusAPI.RagSource, herunterladen: boolean) => {
        const name = dokumentName(quelle);

        // Den Tab sofort beim Klick öffnen. Erst nach dem Laden würde ihn der Browser als Popup blockieren.
        const tab = herunterladen ? null : window.open("", "_blank");
        if (tab) {
            tab.document.title = name;
            tab.document.body.innerText = "Dokument wird geladen …";
        }

        this.mitToken(token => this.client().dokument(quelle.source, token))
            .then(datei => {
                const url = URL.createObjectURL(datei.data);
                if (tab) {
                    tab.location.href = url;
                    return;
                }
                const link = document.createElement("a");
                link.href = url;
                link.download = name + ".pdf";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch(() => {
                if (tab) tab.close();
                alert("Das Dokument „" + name + "“ konnte nicht geladen werden.");
            });
    }
    // Sprache: Reinsprechen und Vorlesen

    // Token für Azure Speech. Es gilt 10 Minuten; nach 9 Minuten wird vorsorglich ein neues geholt.
    // neu = true holt auf jeden Fall ein neues (während das Mikrofon an ist).
    holeSprachToken = (neu: boolean): Promise<SprachZugang> => {
        const z = this.sprachZugang;
        if (!neu && z && Date.now() - z.geholt < SPRACH_TOKEN_MS)
            return Promise.resolve(z);

        return this.mitToken(token => sprachTokenAbrufen(this.props.apiUrl, token))
            .then(zugang => {
                this.sprachZugang = zugang;
                return zugang;
            });
    }

    // Das Eingabefeld wächst mit, auch wenn der Text vom Mikrofon kommt
    feldHoehe = () => {
        const feld = this.eingabeRef.current;
        if (!feld) return;
        feld.style.height = "38px";
        feld.style.height = Math.min(Math.max(38, feld.scrollHeight + 2), 96) + "px";
    }

    // Mikrofon an oder aus. Der erkannte Text kommt ins Eingabefeld und wird nicht automatisch gesendet.
    mikrofonUmschalten = () => {
        if (this.state.hoert) {
            if (this.state.bereit) mikrofonKlang(false);
            this.zuhoerenStoppen(true);
            return;
        }
        tonAusgang();       // schon beim Klick öffnen, sonst lässt der Browser den Klang später nicht zu
        this.vorlesenStoppen();
         this.setState({ hoert: true, bereit: false, zwischentext: "", sprachFehler: null });

        this.holeSprachToken(false).then(z => {
            // Inzwischen wieder ausgeschaltet oder zugeklappt
            if (!this.aktiv || !this.state.hoert) return;

            const config = sdk.SpeechConfig.fromAuthorizationToken(z.token, z.region);
            config.speechRecognitionLanguage = "de-DE";
            const erkenner = new sdk.SpeechRecognizer(config, sdk.AudioConfig.fromDefaultMicrophoneInput());

            // Fachwörter, die sonst leicht falsch erkannt werden
            const woerter = sdk.PhraseListGrammar.fromRecognizer(erkenner);
            FACHWOERTER.forEach(w => woerter.addPhrase(w));

            // Während man spricht: vorläufiger Text in der Zeile über der Eingabe
            erkenner.recognizing = (s, e) => {
                if (this.erkenner === erkenner) this.setState({ zwischentext: e.result.text });
            };

            // Ein Satz ist fertig erkannt: ans Eingabefeld anhängen
            erkenner.recognized = (s, e) => {
                if (this.erkenner !== erkenner || e.result.reason !== sdk.ResultReason.RecognizedSpeech || !e.result.text) return;
                const bisher = this.state.eingabe.trim();
                this.setState({ eingabe: (bisher ? bisher + " " : "") + e.result.text, zwischentext: "" }, this.feldHoehe);
            };

            // Abbruch durch einen Fehler, z. B. Mikrofon gesperrt oder Verbindung weg
            erkenner.canceled = (s, e) => {
                if (this.erkenner === erkenner && e.reason === sdk.CancellationReason.Error)
                    this.zuhoerenStoppen(false, MIKROFON_FEHLER);
            };

            // Erst jetzt hört Azure wirklich zu: Klang und türkiser Knopf sagen "Sie können sprechen"
            erkenner.sessionStarted = () => {
                if (this.erkenner !== erkenner || this.state.bereit) return;
                mikrofonKlang(true);
                this.setState({ bereit: true });
            };
            this.erkenner = erkenner;
            erkenner.startContinuousRecognitionAsync(
                () => {
                    // Solange das Mikrofon an ist, alle 9 Minuten ein neues Token nachreichen
                    window.clearInterval(this.sprachTimer);
                    this.sprachTimer = window.setInterval(() => {
                        this.holeSprachToken(true)
                            .then(neu => { if (this.erkenner === erkenner) erkenner.authorizationToken = neu.token; })
                            .catch(() => { /* beim nächsten Mal wieder versuchen */ });
                    }, SPRACH_TOKEN_MS);
                },
                () => {
                    if (this.erkenner === erkenner) this.zuhoerenStoppen(false, MIKROFON_FEHLER);
                });
        }).catch(() => {
            if (this.aktiv) this.setState({ hoert: false, sprachFehler: SPRACHE_NICHT_DA });
        });
    }

    // behalten = true: Was gerade noch gesprochen wurde, kommt noch ins Feld (Klick aufs Mikrofon).
    // behalten = false: Alles verwerfen, was noch kommt (Senden, Zuklappen, Fehler).
    zuhoerenStoppen = (behalten: boolean, fehler?: string) => {
        window.clearInterval(this.sprachTimer);
        const erkenner = this.erkenner;
        if (!behalten) this.erkenner = null;

        if (erkenner) {
            const fertig = () => {
                erkenner.close();
                if (this.erkenner === erkenner) this.erkenner = null;
            };
            erkenner.stopContinuousRecognitionAsync(fertig, fertig);
        }

         if (this.aktiv) this.setState({ hoert: false, bereit: false, zwischentext: "", sprachFehler: fehler || null });
    }

    // Antwort vorlesen. Ein zweiter Klick auf denselben Knopf hält an.
    vorlesenUmschalten = (historieID: number) => {
        if (this.state.vorlesen === historieID) {
            this.vorlesenStoppen();
            return;
        }

        const runde = this.state.runden.find(r => r.historieID === historieID);
        if (!runde || !runde.antwort) return;

       this.vorlesenStoppen();
        if (this.state.hoert) this.zuhoerenStoppen(true);     // nicht gleichzeitig zuhören und sprechen
        this.setState({ vorlesen: historieID, sprachFehler: null });

        // Tonausgang schon beim Klick öffnen: Der Browser erlaubt Ton nur nach einem Klick
        const ton = tonAusgang();

        const text = vorleseText(runde.antwort);
        const gemerkt = vorleseCache[historieID];
        const mp3 = gemerkt
            ? Promise.resolve(gemerkt)
            : this.holeSprachToken(false)
                .then(z => sprachausgabe(z, text))
                .then(daten => {
                    vorleseCache[historieID] = daten;
                    return daten;
                });

        // decodeAudioData verbraucht die Daten, deshalb eine Kopie (slice), der Speicher behält das Original
        mp3.then(daten => ton.decodeAudioData(daten.slice(0)))
            .then(klang => {
                // Inzwischen auf Stopp, eine andere Antwort oder einen anderen Chat geklickt
                if (!this.aktiv || this.state.vorlesen !== historieID) return;

                const vorleser = ton.createBufferSource();
                vorleser.buffer = klang;
                vorleser.connect(ton.destination);
                vorleser.onended = () => {
                    if (this.vorleser !== vorleser) return;
                    this.vorleser = null;
                    if (this.aktiv) this.setState({ vorlesen: null });
                };
                this.vorleser = vorleser;
                vorleser.start(ton.currentTime + VORLAUF);
            })
            .catch(() => {
                if (this.aktiv && this.state.vorlesen === historieID)
                    this.setState({ vorlesen: null, sprachFehler: VORLESEN_FEHLER });
            });
    }

    vorlesenStoppen = () => {
        if (this.vorleser) {
            const vorleser = this.vorleser;
            this.vorleser = null;
            try { vorleser.stop(); } catch (e) { /* war schon zu Ende */ }
        }
        if (this.aktiv && this.state.vorlesen !== null) this.setState({ vorlesen: null });
    }


    // Anzeige
    

    render() {
        const name = this.props.botName || "Paul";

        // Zugeklappt: nur der runde Knopf
        if (!this.state.offen) {
            const blase = this.blaseLage();
            return (
                <React.Fragment>
                    <button type="button" className={"kibot-knopf" + (this.state.knopfZieht ? " kibot-knopf--zieht" : "")}
                        style={{ right: this.state.anker.rechts, bottom: this.state.anker.unten }}
                        title={"KI-Assistent " + name + " fragen"}
                        aria-label={this.state.ungelesen > 0 ? "KI-Assistent öffnen, neue Antwort" : "KI-Assistent öffnen"}
                        onPointerDown={this.ziehStart("knopf")} onPointerMove={this.ziehBewegung}
                        onPointerUp={this.ziehEnde} onPointerCancel={this.ziehEnde}
                        onClick={e => { if (e.nativeEvent.detail === 0) this.oeffnen(); /* nur Tastatur, die Maus läuft über ziehEnde */ }}>
                        <KIBotLogo art={this.state.wartet ? "arbeitet" : "ruhe"} groesse={34} />
                        {this.state.ungelesen > 0 && <span className="kibot-zahl">{this.state.ungelesen > 9 ? "9+" : this.state.ungelesen}</span>}
                    </button>

                    {this.state.blase && this.props.hinweis &&
                       <div className={blase.klasse} style={blase.stil} role="status">
                            <button type="button" className="kibot-blase-text" onClick={this.oeffnen}>
                                <b>Ich bin {name}, Ihr KI-Assistent.</b>
                                {this.props.hinweis}
                            </button>
                            <button type="button" className="kibot-blase-zu" aria-label="Hinweis schließen" onClick={this.blaseWeg}>×</button>
                        </div>}
                </React.Fragment>
            );
        }

        const f = this.fensterBox();

        return (
            <React.Fragment>
                <div className={"kibot-fenster" + (this.state.maximiert ? " kibot-fenster--max" : "")} role="dialog" aria-label={"KI-Assistent " + name}
                    style={{ right: f.rechts, bottom: f.unten, width: f.breite, height: f.hoehe }}>

                    {!this.state.maximiert &&
                        <div className="kibot-griff" title="Größe ändern"
                            onPointerDown={this.ziehStart("griff")} onPointerMove={this.ziehBewegung}
                            onPointerUp={this.ziehEnde} onPointerCancel={this.ziehEnde} />}

                    <div className="kibot-kopf"
                        onPointerDown={this.ziehStart("kopf")} onPointerMove={this.ziehBewegung}
                        onPointerUp={this.ziehEnde} onPointerCancel={this.ziehEnde}
                        onDoubleClick={this.kopfDoppelklick}>
                        <span className="kibot-avatar"><KIBotLogo groesse={23} /></span>
                        <div className="kibot-kopf-text">
                            <b>{name} · KI-Assistent</b>
                            <span>{this.state.titel || "Neuer Chat"}</span>
                        </div>
                        <button type="button" className={"kibot-kopfknopf" + (this.state.listeOffen ? " kibot-kopfknopf--aktiv" : "")}
                            title="Meine Chats" aria-label="Meine Chats" disabled={this.state.wartet} onClick={this.listeUmschalten}>
                            {Symbole.liste}
                        </button>
                        <button type="button" className="kibot-kopfknopf" title="Neuer Chat" aria-label="Neuer Chat" disabled={this.state.wartet} onClick={this.neuerChat}>
                            {Symbole.neu}
                        </button>
                        <button type="button" className="kibot-kopfknopf" title={this.state.maximiert ? "Verkleinern" : "Maximieren"}
                            aria-label={this.state.maximiert ? "Verkleinern" : "Maximieren"} onClick={() => this.setState({ maximiert: !this.state.maximiert })}>
                            {this.state.maximiert ? Symbole.verkleinern : Symbole.maximieren}
                        </button>
                        <button type="button" className="kibot-kopfknopf" title="Zuklappen" aria-label="Zuklappen" onClick={this.zuklappen}>
                            {Symbole.zuklappen}
                        </button>
                    </div>

                    <div className="kibot-kontext" title={name + " sucht nur in den Handbüchern für diesen Bereich"}>
                        <i />{this.props.thema ? this.props.app + " · " + this.props.thema : this.props.app}
                    </div>

                    <div className="kibot-haupt">
                        <div className="kibot-nachrichten" ref={this.nachrichtenRef} aria-live="polite">
                            {this.inhalt(name)}
                        </div>
                        {this.state.listeOffen &&
                            <div className="kibot-schleier" onClick={() => this.setState({ listeOffen: false })} />}
                        <KIBotVerlauf
                            offen={this.state.listeOffen}
                            chats={this.state.chats}
                            laedt={this.state.chatsLaden}
                            aktiveThreadID={this.state.threadID}
                            onOeffnen={this.chatOeffnen}
                            onNeu={this.neuerChat}
                            onUmbenennen={this.umbenennen}
                            onLoeschen={this.loeschen} />
                    </div>
                    {this.state.sprachFehler &&
                        <div className="kibot-sprachzeile kibot-sprachzeile--fehler" role="alert" title="Hinweis schließen"
                            onClick={() => this.setState({ sprachFehler: null })}>{this.state.sprachFehler}</div>}
                    {this.state.hoert &&
                         <div className="kibot-sprachzeile" role="status">{!this.state.bereit ? "Einen Moment …" : this.state.zwischentext || "Ich höre zu … sprechen Sie jetzt."}</div>}
                    <form className="kibot-eingabe" onSubmit={e => { e.preventDefault(); this.senden(this.state.eingabe); }}>
                        <textarea ref={this.eingabeRef} rows={1} value={this.state.eingabe} placeholder={"Frage an " + name + " …"}
                            aria-label="Frage eingeben" onChange={this.eingabeGeaendert} onKeyDown={this.eingabeTaste} />
                            {SPRACHE_MOEGLICH &&
                            <button type="button" className={"kibot-mikro" + (this.state.bereit ? " kibot-mikro--an" : "")}
                                title={this.state.hoert ? "Zuhören beenden" : "Frage sprechen"} aria-label={this.state.hoert ? "Zuhören beenden" : "Frage sprechen"}
                                aria-pressed={this.state.hoert} onClick={this.mikrofonUmschalten}>
                                {Symbole.mikrofon}
                            </button>}
                        <button type="submit" className="kibot-senden" disabled={this.state.wartet || this.state.eingabe.trim() === ""}>Senden</button>
                    </form>
                </div>

                {this.state.grossesBild &&
                    <div className="kibot-grossansicht" onClick={() => this.setState({ grossesBild: null })}>
                        <img src={this.state.grossesBild} alt="Abbildung aus dem Handbuch"
                            className={this.state.bildZoom ? "kibot-gezoomt" : ""}
                            onClick={this.bildKlick}
                            onMouseMove={e => { if (this.state.bildZoom) this.zoomPunkt(e); }}
                            onLoad={e => {
                                // Höchstens ein Bildpixel pro Bildschirmpixel, sonst rechnet der Browser das Bild hoch und es wird unscharf
                                const bild = e.currentTarget;
                                bild.style.maxWidth = "min(100%, " + bild.naturalWidth / (window.devicePixelRatio || 1) + "px)";
                            }} />
                        <button type="button" aria-label="Großansicht schließen" onClick={() => this.setState({ grossesBild: null })}>×</button>
                    </div>}
            </React.Fragment>
        );
    }

    inhalt(name: string) {
        // Ein alter Chat wird geladen: Logo mit Welle in der Mitte
        if (this.state.chatLaedt) {
            return (
                <div className="kibot-laden">
                    <KIBotLogo art="arbeitet" groesse={56} />
                    <span>Chat wird geöffnet …</span>
                </div>
            );
        }

        const leer = this.state.runden.length === 0;
        const beispiele = this.props.beispielFragen || [];
        const elemente: React.ReactNode[] = [];

        if (this.state.begruessung) {
            if (leer) {
                // key wechselt bei jedem neuen Chat, dadurch baut sich das Logo neu auf
                elemente.push(<div className="kibot-leer" key={"logo" + this.state.neuerChatNr}><KIBotLogo art="aufbau" groesse={76} /></div>);
            }
            elemente.push(
                <div className="kibot-zeile" key="begruessung">
                    <span className="kibot-avatar kibot-avatar--klein"><KIBotLogo groesse={19} /></span>
                    <div className="kibot-antwort">
                        <p>Hallo, ich bin <strong>{name}</strong>, Ihr KI-Assistent für KSLplus. Wie kann ich Ihnen helfen?</p>
                        {leer && beispiele.length > 0 &&
                            <div className="kibot-beispiele">
                            <span className="kibot-beispiele-titel">Zum Beispiel:</span>
                                {beispiele.map(b => <button type="button" key={b} className="kibot-beispiel" onClick={() => this.senden(b)}>{b}</button>)}
                            </div>}
                    </div>
                </div>);
        }

        this.state.runden.forEach((r, i) => {
            elemente.push(
                <KIBotNachricht key={i} runde={r} index={i} botName={name} wartetext={this.state.wartetext}
                    apiUrl={this.props.apiUrl} token={this.props.token} erneuereToken={this.erneuereToken}
                    onErneutSenden={this.erneutSenden}
                    onGrossansicht={url => this.setState({ grossesBild: url, bildZoom: false })}
                    onDokument={this.dokumentOeffnen}
                    onBewerten={this.bewerten}
                    vorlesen={r.historieID !== undefined && r.historieID === this.state.vorlesen}
                    onVorlesen={this.vorlesenUmschalten}
                    onVorschlag={i === this.state.runden.length - 1 ? this.senden : undefined} />);
        });

        return elemente;
    }
}